export const ARTICLE_TYPES = ["generalnews", "announcement", "latest"];
